import React from 'react'

import { Icon } from './Icon'

interface Props {
  className?: string
}

export const CommunityTile = React.memo(({ className }: Props) => {
  return (
    <Icon className={className} width="76" height="76" viewBox="0 0 76 76" fill="none">
      <rect x="0.5" y="0.5" width="75" height="75" rx="1.5" fill="#F9FAFC" stroke="#E8EDF6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.4222 36.3421C30.426 37.2891 28.914 38.7271 27.8184 40.3564C25.9425 43.146 25.334 46.4059 25.334 48.5407V49.8146L26.4493 50.3843C28.1392 51.2475 32.5647 52.7777 38.0007 52.7777C43.4366 52.7777 47.8621 51.2475 49.552 50.3843L50.6673 49.8146V48.5407C50.6673 46.4059 50.0588 43.146 48.1829 40.3564C47.0873 38.7271 45.5753 37.2891 43.5791 36.3421C42.0257 37.5263 40.0941 38.2282 38.0007 38.2282C35.9072 38.2282 33.9756 37.5263 32.4222 36.3421ZM30.4007 28.8138C30.4007 24.5597 33.8033 21.1111 38.0007 21.1111C42.198 21.1111 45.6007 24.5597 45.6007 28.8138C45.6007 33.0679 42.198 36.5165 38.0007 36.5165C33.8033 36.5165 30.4007 33.0679 30.4007 28.8138Z"
        fill="#3F38FF"
      />
      <path
        d="M28.6721 31.2206C28.6721 33.44 27.6481 35.4032 26.0786 36.5975C27.7554 37.3007 28.9981 38.488 29.8731 39.8524C31.2279 41.9651 31.6674 44.4338 31.6674 46.0505V47.0153L30.8619 47.4467C29.6414 48.1004 26.4452 49.2593 22.5192 49.2593C18.5933 49.2593 15.3971 48.1004 14.1766 47.4467L13.3711 47.0153V46.0505C13.3711 44.4338 13.8105 41.9651 15.1654 39.8524C16.0404 38.488 17.2832 37.3006 18.96 36.5974C17.3906 35.4031 16.3667 33.4399 16.3667 31.2206C16.3667 27.5805 19.1213 24.6296 22.5194 24.6296C25.9175 24.6296 28.6721 27.5805 28.6721 31.2206Z"
        fill="#5D6B80"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.334 49.0643C27.9335 48.7061 29.9496 47.9353 30.8618 47.4467L31.6673 47.0152V46.0505C31.6673 44.4338 31.2279 41.965 29.873 39.8524C29.6344 39.4804 29.3686 39.1216 29.074 38.7822C28.6062 39.2774 28.1886 39.806 27.8184 40.3564C25.9425 43.146 25.334 46.4059 25.334 48.5407V49.0643Z"
        fill="black"
      />
      <path
        d="M59.635 31.2206C59.635 33.44 58.611 35.4032 57.0415 36.5975C58.7183 37.3007 59.961 38.488 60.836 39.8524C62.1908 41.9651 62.6303 44.4338 62.6303 46.0505V47.0153L61.8247 47.4467C60.6043 48.1004 57.4081 49.2593 53.4821 49.2593C49.5562 49.2593 46.36 48.1004 45.1395 47.4467L44.334 47.0153V46.0505C44.334 44.4338 44.7734 41.9651 46.1283 39.8524C47.0033 38.488 48.2461 37.3006 49.9229 36.5974C48.3535 35.4031 47.3296 33.4399 47.3296 31.2206C47.3296 27.5805 50.0842 24.6296 53.4823 24.6296C56.8804 24.6296 59.635 27.5805 59.635 31.2206Z"
        fill="#5D6B80"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.9273 38.7822C46.6327 39.1216 46.3668 39.4804 46.1283 39.8524C44.7734 41.965 44.334 44.4338 44.334 46.0505V47.0152L45.1395 47.4467C46.0517 47.9353 48.0678 48.7061 50.6673 49.0643V48.5407C50.6673 46.4059 50.0588 43.146 48.1829 40.3564C47.8128 39.806 47.3951 39.2774 46.9273 38.7822Z"
        fill="black"
      />
    </Icon>
  )
})
